import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import { AdminSidebar } from "@/components/sidebars";
import { apiClient, formatApiError, API } from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["pendiente", "asignada", "en_camino", "completada", "cancelada"];

export default function AdminSolicitudes() {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("");

  const load = () => {
    const q = filter ? `?status=${filter}` : "";
    apiClient.get(`/admin/solicitudes${q}`).then(({ data }) => setList(data)).catch(() => {});
  };
  useEffect(load, [filter]);

  const updateStatus = async (sid, status) => {
    try {
      await apiClient.patch(`/admin/solicitudes/${sid}`, { status });
      toast.success("Solicitud actualizada");
      load();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    }
  };

  return (
    <AppLayout sidebar={AdminSidebar}>
      <header className="app-header">
        <h1>Solicitudes de Servicio</h1>
        <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
          <select value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="filter-status">
            <option value="">Todas</option>
            {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      </header>
      <div className="panel">
        <table className="data-table">
          <thead><tr><th>Fecha</th><th>Tipo</th><th>Cliente</th><th>Beneficiario</th><th>Ubicación / Tel</th><th>Descripción</th><th>Status</th><th>Expediente</th></tr></thead>
          <tbody>
            {list.map((s) => (
              <tr key={s.id} data-testid={`sol-row-${s.id}`}>
                <td>{new Date(s.created_at).toLocaleString("es-MX")}</td>
                <td><strong>{s.tipo.toUpperCase()}</strong></td>
                <td>{s.user_nombre}<br/><small>{s.user_email}</small></td>
                <td>{s.beneficiario?.nombre}<br/><small>{s.beneficiario?.municipio}, {s.beneficiario?.estado} · CP {s.beneficiario?.codigo_postal}</small></td>
                <td>{s.ubicacion || s.beneficiario?.calle + " " + (s.beneficiario?.numero_ext || "")}<br/><small>{s.telefono_contacto}</small></td>
                <td style={{ maxWidth: 280 }}>{s.descripcion}</td>
                <td>
                  <select value={s.status} onChange={(e) => updateStatus(s.id, e.target.value)} data-testid={`update-${s.id}`}>
                    {STATUSES.map((st) => <option key={st} value={st}>{st}</option>)}
                  </select>
                </td>
                <td>
                  <div style={{ display: "flex", gap: 6, flexDirection: "column" }}>
                    <button onClick={() => openExpedientePDF(s.id)} className="btn-mini" data-testid={`pdf-${s.id}`} title="Ver expediente PDF">
                      <i className="fas fa-file-pdf" /> PDF
                    </button>
                    <button onClick={() => copyExpedienteJSON(s.id)} className="btn-mini" data-testid={`json-${s.id}`} title="Copiar JSON al portapapeles">
                      <i className="fas fa-code" /> JSON
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AppLayout>
  );
}
